// extracted by mini-css-extract-plugin
export default {"nav":"XVPL8q","withNewColorWiring":"zeoHcU","icon":"_3sKSe","withCount":"_SWmiG","badge":"NUcgT6"};